import React from 'react';
import { Modal } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

import OnTraccrButton from '../common/buttons/OnTraccrButton';
import colors from '../constants/Colors';

export default function WorkflowMarketplaceSuccessContainer({
  onClose,
  workflow,
}) {
  if (!workflow) return null;

  return (
    <Modal
      visible
      centered
      zIndex={1100}
      wrapClassName="workflow-marketplace-success-modal-wrap"
      className="workflow-marketplace-success-modal"
      onCancel={onClose}
      footer={null}
      width={480}
      maskClosable={false}
    >
      <div className="workflow-marketplace-success-modal-body">
        <CheckCircleOutlined
          className="workflow-marketplace-success-modal-icon"
          style={{ color: colors.ONTRACCR_SUCCESS }}
        />
        <div className="workflow-marketplace-success-modal-text">
          <div className="workflow-marketplace-success-modal-title">
            Workflow successfully imported
          </div>
          <p className="workflow-marketplace-success-modal-description">
            <strong>{workflow}</strong>
            {' '}
            is now active in your account. Refresh the page to see your new workflow.
          </p>
        </div>
        <div className="workflow-marketplace-success-modal-actions">
          <OnTraccrButton title="Close" type="cancel" onClick={onClose} />
          <OnTraccrButton
            title="Refresh page"
            type="primary"
            onClick={() => window.location.reload()}
          />
        </div>
      </div>
    </Modal>
  );
}

WorkflowMarketplaceSuccessContainer.propTypes = {
  onClose: PropTypes.func.isRequired,
  workflow: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
};
